(function () {
    "use strict";

    function getVisibleContainer() {
        const containers = document.querySelectorAll('.container:not(.mega-menu)');
        for (let i = 0; i < containers.length; i++) {
            const c = containers[i];
            if (c.offsetWidth > 0 || c.offsetHeight > 0) {
                return c;
            }
        }
        const econs = document.querySelectorAll('.e-con-inner');
        for (let i = 0; i < econs.length; i++) {
            const ec = econs[i];
            if (ec.offsetWidth > 0 || ec.offsetHeight > 0) {
                return ec;
            }
        }
        return document.body;
    }

    function getContainerGap(container) {
        if (container === document.body) {
            return 0;
        }
        const style = window.getComputedStyle(container);
        const paddingLeft = parseFloat(style.paddingLeft) || 0;
        const paddingRight = parseFloat(style.paddingRight) || 0;
        const borderLeft = parseFloat(style.borderLeftWidth) || 0;
        const borderRight = parseFloat(style.borderRightWidth) || 0;
        const gap = paddingLeft + paddingRight + borderLeft + borderRight;
        return gap > 0 ? gap / 2 : 0;
    }

    function getDocumentOffset(el) {
        const rect = el.getBoundingClientRect();
        return {
            top: rect.top + (window.pageYOffset || document.documentElement.scrollTop),
            left: rect.left + (window.pageXOffset || document.documentElement.scrollLeft)
        };
    }

    function fixMegaMenu(menu) {
        if (!menu) return;

        if (menu.closest('.menu-popup')) return;

        const container = getVisibleContainer();
        const container_gap = getContainerGap(container);

        const menuItem = menu.closest('.menu-item');
        if (!menuItem) return;

        const menuItemOffset = getDocumentOffset(menuItem);
        const containerOffset = getDocumentOffset(container);
        const isRtl = document.body.classList.contains('rtl');
        const viewportWidth = document.documentElement.clientWidth || window.innerWidth;

        const isVertical = menu.closest('.nav-menu-list--vertical') !== null;
        const isDropdown = menu.closest('.menu-widget-nav--dropdown') !== null;
        const isFullWidth = menu.classList.contains('sub-menu--full-width');
        const isCustomWidth = menu.classList.contains('sub-menu--custom-width');

        const verticalNavList = menu.closest('.nav-menu-list--vertical');
        let topReferenceItem = menuItem;
        if (isDropdown && verticalNavList) {
            topReferenceItem = verticalNavList;
        }
        const topRefOffset = getDocumentOffset(topReferenceItem);

        // Calculate top offset
        let megaMenuOffsetTop;
        if (isVertical) {
            if (isDropdown) {
                megaMenuOffsetTop = topRefOffset.top - (window.pageYOffset || document.documentElement.scrollTop);
            } else {
                megaMenuOffsetTop = menuItemOffset.top - (window.pageYOffset || document.documentElement.scrollTop) - 20;
            }
        } else {
            megaMenuOffsetTop = menuItemOffset.top + menuItem.offsetHeight - (window.pageYOffset || document.documentElement.scrollTop);
        }
        menu.style.top = megaMenuOffsetTop + 'px';

        // Apply min-height in dropdown mode to match at least the main vertical list height
        if (isDropdown && verticalNavList) {
            const minHeightPx = verticalNavList.offsetHeight;
            if (minHeightPx > 0) {
                menu.style.minHeight = minHeightPx + 'px';
            }
        }

        // Calculate left/right positioning and width
        let menuWidth;
        if (isVertical) {
            if (isRtl) {
                menu.style.right = (viewportWidth - menuItemOffset.left) + 'px';
                menu.style.left = 'auto';
                menuWidth = menuItemOffset.left - containerOffset.left - container_gap;
            } else {
                const megaMenuOffsetLeft = menuItemOffset.left + menuItem.offsetWidth;
                menu.style.left = megaMenuOffsetLeft + 'px';
                menu.style.right = 'auto';
                menuWidth = (containerOffset.left + container.offsetWidth) - (menuItemOffset.left + menuItem.offsetWidth) - container_gap;
            }
        } else {
            if (isFullWidth) {
                menu.style.left = (containerOffset.left + container_gap) + 'px';
                menu.style.right = 'auto';
                menuWidth = container.offsetWidth - (container_gap * 2);
            } else {
                let megaMenuOffsetLeft = menuItemOffset.left;
                if (isRtl) {
                    const menuItemInnerWidth = menuItem.clientWidth;
                    megaMenuOffsetLeft = viewportWidth - megaMenuOffsetLeft - menuItemInnerWidth;
                    menu.style.right = megaMenuOffsetLeft + 'px';
                    menu.style.left = 'auto';
                    menuWidth = menuItemOffset.left - containerOffset.left - container_gap;
                } else {
                    menu.style.left = megaMenuOffsetLeft + 'px';
                    menu.style.right = 'auto';
                    menuWidth = (containerOffset.left + container.offsetWidth) - menuItemOffset.left - container_gap;
                }
            }
        }

        // Apply max-width constraint unless custom width is defined
        if (!isCustomWidth) {
            menu.style.maxWidth = menuWidth + 'px';
        }

        // Apply content scroll calculation if enabled
        if (menu.classList.contains('sub-menu--content-scroll')) {
            const remInPx = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
            const bottomGap = 2 * remInPx;
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            const availableHeight = viewportHeight - megaMenuOffsetTop - bottomGap;

            if (availableHeight > 0) {
                menu.style.maxHeight = availableHeight + 'px';
                menu.style.overflowY = 'auto';
                menu.style.overflowX = 'hidden';
            } else {
                menu.style.maxHeight = '0px';
                menu.style.overflowY = 'auto';
                menu.style.overflowX = 'hidden';
            }
        } else {
            menu.style.maxHeight = '';
            menu.style.overflowY = '';
            menu.style.overflowX = '';
        }
    }

    document.addEventListener('mouseenter', function (e) {
        if (e.target.matches && e.target.matches('.nav-menu-list .menu-item-has-mega-menu')) {
            const children = e.target.children;
            for (let i = 0; i < children.length; i++) {
                if (children[i].classList.contains('sub-menu--mega-menu')) {
                    fixMegaMenu(children[i]);
                }
            }
        }
    }, true);

    document.addEventListener('touchstart', function (e) {
        const item = e.target.closest('.nav-menu-list .menu-item-has-mega-menu');
        if (item) {
            const children = item.children;
            for (let i = 0; i < children.length; i++) {
                if (children[i].classList.contains('sub-menu--mega-menu')) {
                    fixMegaMenu(children[i]);
                }
            }
        }
    }, {passive: true});

    function triggerFixAll() {
        const megaMenus = document.querySelectorAll('.nav-menu-list .menu-item-has-mega-menu .sub-menu--mega-menu');
        megaMenus.forEach(menu => {
            fixMegaMenu(menu);
        });
    }

    window.addEventListener('resize', triggerFixAll);
    window.addEventListener('scroll', triggerFixAll);

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            triggerFixAll();
            setTimeout(triggerFixAll, 1000);
            initSidebarOffcanvasSubmenus();
        });
    } else {
        triggerFixAll();
        setTimeout(triggerFixAll, 1000);
        initSidebarOffcanvasSubmenus();
    }


    function loadAjaxMenuIfNeeded(menuItem) {
        if (!menuItem) {
            return;
        }
        if (menuItem.classList.contains('loaded')) {
            return;
        }
        if (menuItem.classList.contains('loading')) {
            return;
        }

        menuItem.classList.add('loading');
        const menu_id = menuItem.getAttribute('data-id');

        const formData = new URLSearchParams();
        formData.append('action', 'negarshop_ajax_megamenu');
        formData.append('menu_id', menu_id);

        fetch(NS_OBJ.ajax_url, {
            method: 'POST',
            body: formData,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
            .then(res => res.json())
            .then(response => {
                if (response.success) {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = response.data;
                    while (tempDiv.firstChild) {
                        menuItem.appendChild(tempDiv.firstChild);
                    }

                    menuItem.classList.add('loaded');
                    triggerFixAll();


                    document.querySelectorAll('.swiper[data-settings]').forEach(el => {
                        el.dispatchEvent(new CustomEvent('init_carousel', {bubbles: true}));
                    });
                }
                menuItem.classList.remove('loading');
            })
            .catch(err => {
                console.error(err);
                menuItem.classList.remove('loading');
            });
    }


    document.addEventListener('click', function (e) {
        const tabItem = e.target.closest('.nav-menu-list .menu-item > .sub-menu--type-two_level > .tabs li:not(.active)');
        if (!tabItem) {
            return;
        }

        e.preventDefault();

        const tabsWrapper = tabItem.closest('.tabs');
        const contentsWrapper = tabItem.closest('.sub-menu--type-two_level').querySelector('.contents');

        tabsWrapper.querySelector('li.active').classList.remove('active');
        tabItem.classList.add('active');

        const index = Array.from(tabsWrapper.children[0].children ?? []).indexOf(tabItem);
        contentsWrapper.querySelector('ul.show').classList.remove('show');
        if (typeof contentsWrapper.children[index] != "undefined") {
            contentsWrapper.children[index].classList.add('show');
        }
    });

    function updateMenuOverlayActiveState() {
        const activeNav = document.querySelector(
            '.menu-widget-nav--overlay.is-active, ' +
            '.menu-widget-nav--overlay.is-focused, ' +
            '.menu-widget-nav--overlay:has(.menu-item.show), ' +
            '.menu-widget-nav--overlay:has(.vertical-menu.show), ' +
            '.menu-widget-nav--overlay:has(.menu-item-has-children:hover), ' +
            '.menu-widget-nav--overlay:has(.menu-item-has-mega-menu:hover), ' +
            '.menu-widget-nav--overlay:has(.vertical-menu:hover)'
        );
        if (activeNav) {
            document.body.classList.add('ns-menu-overlay-active');
            document.documentElement.classList.add('ns-menu-overlay-active');
        } else {
            document.body.classList.remove('ns-menu-overlay-active');
            document.documentElement.classList.remove('ns-menu-overlay-active');
        }
    }

    document.addEventListener('touchmove', function (e) {
        if (e.target && e.target.classList && e.target.classList.contains('ns-menu-overlay')) {
            e.preventDefault();
        }
    }, { passive: false });

    document.addEventListener('wheel', function (e) {
        if (e.target && e.target.classList && e.target.classList.contains('ns-menu-overlay')) {
            e.preventDefault();
        }
    }, { passive: false });

    // Handle menu trigger: hover
    document.addEventListener('mouseenter', function (e) {

        if (!e.target.matches || !e.target.matches('.nav-menu-list .menu-item')) return;

        if (e.target && e.target.closest('.menu-popup')) return;

        const nav = e.target.closest('.menu-widget-nav');
        if (!nav) return;
        const trigger = nav.getAttribute('data-trigger') || 'hover';

        if (trigger === 'hover') {
            if (e.target.classList.contains('menu-item-has-children') || e.target.classList.contains('menu-item-has-mega-menu')) {
                e.target.classList.add('show');
                if (e.target.hasAttribute('data-id')) {
                    loadAjaxMenuIfNeeded(e.target);
                }
                updateMenuOverlayActiveState();
            }
        }
    }, true);

    document.addEventListener('mouseleave', function (e) {
        if (!e.target.matches || !e.target.matches('.nav-menu-list .menu-item')) return;

        if (e.target && e.target.closest('.menu-popup')) return;

        const nav = e.target.closest('.menu-widget-nav');
        if (!nav) return;
        const trigger = nav.getAttribute('data-trigger') || 'hover';

        if (trigger === 'hover') {
            e.target.classList.remove('show');
            updateMenuOverlayActiveState();
        }
    }, true);

    // Handle menu trigger: click
    document.addEventListener('click', function (e) {
        const link = e.target.closest('.nav-menu-list .menu-item > a');
        if (!link) {
            // Close all open click-triggered dropdowns if clicked outside
            document.querySelectorAll('.menu-widget-nav[data-trigger="click"] .menu-item.show').forEach(item => {
                if (!item.contains(e.target)) {
                    item.classList.remove('show');
                }
            });
            updateMenuOverlayActiveState();
            return;
        }

        const menuItem = link.parentElement;
        const nav = menuItem.closest('.menu-widget-nav');
        if (!nav) return;
        const trigger = nav.getAttribute('data-trigger') || 'hover';

        const isSidebar = nav.classList.contains('menu-widget-nav--sidebar');
        if (trigger === 'click' || isSidebar) {
            const hasChildren = menuItem.classList.contains('menu-item-has-children') || menuItem.classList.contains('menu-item-has-mega-menu');
            if (hasChildren) {
                e.preventDefault();
                e.stopPropagation();

                const isShown = menuItem.classList.contains('show');

                // Close siblings at the same level
                const siblings = menuItem.parentElement.children;
                for (let i = 0; i < siblings.length; i++) {
                    if (siblings[i] !== menuItem) {
                        siblings[i].classList.remove('show');
                        siblings[i].querySelectorAll('.menu-item.show').forEach(child => {
                            child.classList.remove('show');
                        });
                    }
                }

                if (isShown) {
                    menuItem.classList.remove('show');
                    menuItem.querySelectorAll('.menu-item.show').forEach(child => {
                        child.classList.remove('show');
                    });
                } else {
                    menuItem.classList.add('show');
                    if (menuItem.hasAttribute('data-id')) {
                        loadAjaxMenuIfNeeded(menuItem);
                    }
                }
                updateMenuOverlayActiveState();
            }
        }
    });

    // Dropdown vertical menu hover events
    document.addEventListener('mouseenter', function (e) {
        if (!e.target || !e.target.closest) return;
        const dropdownNav = e.target.closest('.menu-widget-nav--dropdown[data-dropdown-trigger="hover"]');
        if (dropdownNav) {
            const verticalMenu = e.target.closest('.header-main-menu.vertical-menu');
            if (verticalMenu) {
                verticalMenu.classList.add('show');
                updateMenuOverlayActiveState();
            }
        }
    }, true);

    document.addEventListener('mouseleave', function (e) {
        if (!e.target || !e.target.closest) return;
        const dropdownNav = e.target.closest('.menu-widget-nav--dropdown[data-dropdown-trigger="hover"]');
        if (dropdownNav) {
            const verticalMenu = e.target.closest('.header-main-menu.vertical-menu');
            if (verticalMenu) {
                const related = e.relatedTarget;
                if (!related || !verticalMenu.contains(related)) {
                    verticalMenu.classList.remove('show');
                    updateMenuOverlayActiveState();
                }
            }
        }
    }, true);

    // Toggle dropdown vertical menu
    document.addEventListener('click', function (e) {
        const toggleBtn = e.target.closest('.vertical-menu-toggle');
        if (toggleBtn) {
            e.preventDefault();
            const parentMenu = toggleBtn.closest('.vertical-menu');
            if (parentMenu) {
                parentMenu.classList.toggle('show');
                updateMenuOverlayActiveState();
            }
            return;
        }

        // Close all dropdown vertical menus when clicking outside
        document.querySelectorAll('.menu-widget-nav--dropdown .header-main-menu.vertical-menu.show').forEach(menu => {
            if (!menu.contains(e.target)) {
                menu.classList.remove('show');
            }
        });
        updateMenuOverlayActiveState();
    });

    // Handle menu backdrop overlay clicks and state
    document.addEventListener('click', function (e) {
        if (e.target && e.target.classList.contains('ns-menu-overlay')) {
            document.querySelectorAll('.menu-widget-nav--overlay .menu-item.show').forEach(item => {
                item.classList.remove('show');
            });
            document.querySelectorAll('.menu-widget-nav--overlay .header-main-menu.vertical-menu.show').forEach(menu => {
                menu.classList.remove('show');
            });
            document.querySelectorAll('.menu-widget-nav--overlay').forEach(nav => {
                nav.classList.remove('is-active', 'is-focused');
            });
            updateMenuOverlayActiveState();
        }
    });

    function initSidebarOffcanvasSubmenus() {
        if (typeof bootstrap === 'undefined' || !bootstrap.Offcanvas) {
            return;
        }

        // Process all menu-popup offcanvases
        document.querySelectorAll('.menu-popup.offcanvas').forEach(parentOffcanvas => {
            const isRtl = document.body.classList.contains('rtl');

            // Find all menu items with children inside this offcanvas
            parentOffcanvas.querySelectorAll('.menu-item-has-children, .menu-item-has-mega-menu').forEach(menuItem => {
                if (menuItem.classList.contains('sub-offcanvas-initialized')) return;
                menuItem.classList.add('sub-offcanvas-initialized');

                const subMenuUl = menuItem.querySelector(':scope > ul.sub-menu');
                if (!subMenuUl) return;

                // Create a unique ID for the sub-menu offcanvas
                const subOffcanvasId = 'ns-sub-offcanvas-' + Math.random().toString(36).substr(2, 9);

                // Determine direction (same as parent)
                let dirClass = 'offcanvas-start';
                if (parentOffcanvas.classList.contains('offcanvas-end')) {
                    dirClass = 'offcanvas-end';
                }

                // Create offcanvas container
                const subOffcanvas = document.createElement('div');
                subOffcanvas.className = `offcanvas ${dirClass} menu-popup sub-menu-offcanvas`;
                subOffcanvas.id = subOffcanvasId;
                subOffcanvas.setAttribute('tabindex', '-1');

                // Create header
                const header = document.createElement('div');
                header.className = 'offcanvas-header justify-content-start';

                // Back button
                const backBtn = document.createElement('button');
                backBtn.type = 'button';
                backBtn.className = 'btn-back button button--unstyled px-3';
                backBtn.innerHTML = isRtl ? '<i class="fi fi-br-angle-right"></i>' : '<i class="fi fi-br-angle-left"></i>';
                backBtn.setAttribute('title', window.negarshop_i18n?.back || 'بازگشت');

                backBtn.addEventListener('click', function () {
                    const subInst = bootstrap.Offcanvas.getInstance(subOffcanvas);
                    if (subInst) subInst.hide();

                    const currentParentOffcanvas = menuItem.closest('.menu-popup.offcanvas');
                    const parentInst = bootstrap.Offcanvas.getOrCreateInstance(currentParentOffcanvas);
                    if (parentInst) parentInst.show();
                });

                // Title
                const parentLink = menuItem.querySelector(':scope > a');
                const parentText = parentLink ? parentLink.textContent.trim() : '';
                const title = document.createElement('h5');
                title.className = 'offcanvas-title';
                title.textContent = parentText;

                header.appendChild(backBtn);
                header.appendChild(title);

                // Body
                const body = document.createElement('div');
                body.className = 'offcanvas-body';

                // Move the subMenuUl inside body
                subMenuUl.style.position = 'static';
                subMenuUl.style.display = 'block';
                subMenuUl.style.opacity = '1';
                subMenuUl.style.visibility = 'visible';
                subMenuUl.className = 'nav-menu-list nav-menu-list--vertical';
                body.appendChild(subMenuUl);

                subOffcanvas.appendChild(header);
                subOffcanvas.appendChild(body);

                document.body.appendChild(subOffcanvas);

                if (parentLink) {
                    parentLink.addEventListener('click', function (e) {
                        e.preventDefault();
                        e.stopPropagation();

                        const currentParentOffcanvas = menuItem.closest('.menu-popup.offcanvas');
                        const parentInst = bootstrap.Offcanvas.getInstance(currentParentOffcanvas);
                        if (parentInst) parentInst.hide();

                        const subInst = bootstrap.Offcanvas.getOrCreateInstance(subOffcanvas);
                        if (subInst) subInst.show();
                    });
                }
            });
        });
    }

})();

